import angular from 'angular';

import 'angular-sanitize/angular-sanitize.min';
import 'lodash/lodash';
import 'jquery/src/jquery';
import 'angular-auto-complete/angular-auto-complete';
import 'angular-auto-complete/angular-auto-complete.css';

import AutoComplete from '@front10/healthcare-book/src/app/common/autocomplete/autocomplete.component';
import Button from '@front10/healthcare-book/src/app/common/button/button.module';
import Checkbox from '@front10/healthcare-book/src/app/common/checkbox/checkbox.module';
import CheckboxGroup from '@front10/healthcare-book/src/app/common/checkbox-group/checkbox-group.module';
import DateGroup from '@front10/healthcare-book/src/app/common/date-group/date-group.module';
import GenderGroup from '@front10/healthcare-book/src/app/common/gender-group/gender-group.module';
import Pagination from '@front10/healthcare-book/src/app/common/pagination/pagination.module';
import Rating from '@front10/healthcare-book/src/app/common/rating/rating.modules';
import Select from '@front10/healthcare-book/src/app/common/select/select.module';

import AddressSelector from '@front10/healthcare-book/src/app/components/address-selector/address-selector.module';
import AppointmentFinder from '@front10/healthcare-book/src/app/components/appointment-finder/appointment-finder.modules';
import AutoCompleteWizardSearch from '@front10/healthcare-book/src/app/components/autocomplete-wizard-search/autocomplete-wizard-search.module';
import DateSelector from '@front10/healthcare-book/src/app/components/date-selector/date-selector.module';
import DoctorAdvanceFilterOptions from '@front10/healthcare-book/src/app/components/doctor-advance-filter-options/doctor-advance-filter-options.module';
import DoctorAppointmenCard from '@front10/healthcare-book/src/app/components/doctor-appointments-card/doctor-appointments-card.modules';
import DoctorFilter from '@front10/healthcare-book/src/app/components/doctor-filter/doctor-filter.module';
import DoctorList from '@front10/healthcare-book/src/app/components/doctor-list/doctor-list.modules';
import DoctorOrCondition from '@front10/healthcare-book/src/app/components/doctor-or-condition-selector/doctor-or-condition-selector.module';
import DoctorSearch from '@front10/healthcare-book/src/app/components/doctor-search/doctor-search.module';
import SearchAppointment from '@front10/healthcare-book/src/app/components/search-appointment/search-appointment.modules';

import highlight from '@front10/healthcare-book/src/app/common/filters/highlight.filter';
import frFocus from '@front10/healthcare-book/src/app/common/directives/fr-focus.directive';

import SearchAppointmentComponent from './search-appointment.component';

export default angular.module('searchAppointment', [
    'autoCompleteModule',
    Button,
    Checkbox,
    CheckboxGroup,
    DateGroup,
    GenderGroup,
    Pagination,
    Rating,
    Select,

    DateSelector,
    DoctorAdvanceFilterOptions,
    DoctorFilter,
    DoctorAppointmenCard,
    DoctorList,
    AutoCompleteWizardSearch,
    AddressSelector,
    DoctorOrCondition,
    SearchAppointment,
    DoctorSearch,
    AppointmentFinder
])
    .component('searchAppointmentComponent', SearchAppointmentComponent)
    .component('frAutoComplete', AutoComplete)
    .filter('highlight', highlight)
    .directive('frFocus', frFocus)
    .name;


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/search-appointment/search-appointment.module.js
// module id = 346
// module chunks = 0